import CouponInputAuth from "components/CouponInputAuth";
import React from "react";

type Props = {
  couponCode: string;
  setCouponCode: React.Dispatch<React.SetStateAction<string>>;
  validCoupon: (code: string) => void;
  isValidCoupon: boolean;
  couponData?: any;
};

const Coupon: React.FC<Props> = ({
  couponCode,
  setCouponCode,
  validCoupon,
  isValidCoupon,
  couponData,
}): JSX.Element => {
  return (
    <div className="flex flex-row justify-center">
      <div className="flex flex-col w-1/2 ml-2">
        <CouponInputAuth
          placeholder={"Coupon code"}
          label="Coupon code"
          value={couponCode}
          onChange={(e: any) => setCouponCode(e.target.value)}
          onBlur={() => validCoupon(couponCode)}
        />
      </div>
      <div className="flex flex-col w-1/2 my-auto">
        <span
          className="text-base font-sora mt-5 ml-4"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: isValidCoupon ? "#408E5A" : "#FD5B28",
          }}
        >
          {couponData && (isValidCoupon ? couponData.name : couponData)}
        </span>
      </div>
    </div>
  );
};

export default Coupon;
